import React from 'react';
import './AttProvider.css';
import Footer from '../../Includes/Footer';
import Header from '../../Includes/Header';
import logo1 from "../../Includes/Images/g3-2.png";
import provider1 from "../../Includes/Images/Group-1000004727-2.png";

const AttProvider = () => {
  const phoneNumber = "+1-888-348-6689";

  return (
    <>
      <Header />
      <div className="attContainer">
        <div className="heroContainer">
          {/* Header Section - Improved alignment and styling */}
          <header className="attHeader">
            <div className="attLogo">
              <img src={logo1} alt="AT&T Authorized Retailers" />
            </div>
          </header>

          {/* Hero Section - Improved layout with better text visibility */}
          <section className="attHeroSection">
            <div className="attHeroContent">
              <h1 className="attHeroTitle">
                AT&T Offers Everything You Need For A Truly Reliable Connection.
              </h1>
              <p className="attHeroSubtitle">
                Unmatched Speeds, Impressive Wi-Fi Coverage, Unlimited Data, Security Features, And More.
              </p>
              <button className="attConnectButton">Get Connected with AT&T Services</button>
              <a href={`tel:${phoneNumber}`} className="attCallToAction">
                <span className="attPhoneIcon">📞</span> {phoneNumber}
              </a>
            </div>
            <div className="attHeroImageContainer">
              {/* Hero image container (empty in your original code) */}
            </div>
          </section>
        </div>

        {/* Popular Services Section - Fixed styling and layout */}
        <section className="attSpecServicesSection">
          <h2 className="attSectionHeading">Most Popular AT&T Plans</h2>
          <p className="attSectionSubheading">
            AT&T provides super-fast internet and wireless services across the United States. With powerful Wi-Fi that ensures whole-home connectivity.
          </p>
          <div className="attSpecServicesGrid">
            <div className="attSpecServicesImages">
              <div className="attSpecImageContainer">
                <img src={provider1} alt="Woman with colorful lighting" className="attSpecFullImage" />
              </div>
            </div>
            <div className="attSpecServicesContent">
              <div className="attSpecServiceCard">
                <div className="attSpecServiceIcon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <circle cx="12" cy="12" r="4"></circle>
                    <line x1="21.17" y1="8" x2="12" y2="8"></line>
                    <line x1="3.95" y1="6.06" x2="8.54" y2="14"></line>
                    <line x1="10.88" y1="21.94" x2="15.46" y2="14"></line>
                  </svg>
                </div>
                <h3 className="attSpecServiceTitle">Straightforward Pricing</h3>
                <p className="attSpecServiceDescription">
                  There are no surprises. AT&T guarantees straightforward pricing with no price increase at 12 months and no annual contract.
                </p>
              </div>

              <div className="attSpecServiceCard">
                <div className="attSpecServiceIcon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect>
                    <polyline points="17 2 12 7 7 2"></polyline>
                  </svg>
                </div>
                <h3 className="attSpecServiceTitle">Unlimited Data</h3>
                <p className="attSpecServiceDescription">
                  Enjoy streaming, gaming, and video-calling with unlimited internet data from AT&T.
                </p>
              </div>

              <div className="attSpecServiceCard">
                <div className="attSpecServiceIcon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                  </svg>
                </div>
                <h3 className="attSpecServiceTitle">No Equipment Fees</h3>
                <p className="attSpecServiceDescription">
                  With AT&T, you don't have to worry about paying extra charges for your equipment.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Plans Section - Improved card design and responsive layout */}
        <div className="att-offers-container">
      <div className="offers-header">
        <h2 className="attSectionHeading">Most Popular AT&T Plans</h2>
        <p className="attSectionSubheading">
          Enjoy Consistent Speeds, Reliability, Guaranteed Simple, Straightforward Pricing And Complete Wi-Fi® Coverage.
        </p>
      </div>
      
      <div className="offers-cards">
        {/* Fiber 300 Mbps */}
        <div className="offer-card offer-card-basic">
          <div className="offer-header">
            <h3 className="offer-name">AT&T Fiber Internet 300 Mbps</h3>
            <p className="offer-price">$55<span>/mo. plus taxes</span></p>
          </div>
          <div className="offer-features">
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">300 Mbps equal upload and download speeds</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">Connect 10+ devices at one time</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">AT&T All-Fi™ – Powerful Wi-Fi you can rely on</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">15X faster upload speeds than cable</span>
            </div>
          </div>
          <div className="offer-footer">
            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="call-button">{phoneNumber}</a>
            <p className="disclaimer">Restrictions apply. Internet req'd. Taxes extra. Pricing subj. to change</p>
          </div>
        </div>
        
        {/* Fiber 500 Mbps */}
        <div className="offer-card offer-card-standard">
          <div className="offer-header">
            <h3 className="offer-name">AT&T Fiber Internet 500 Mbps</h3>
            <p className="offer-price">$65<span>/mo. plus taxes</span></p>
          </div>
          <div className="offer-features">
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">500 Mbps equal upload and download speeds</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">Great for multiplayer gaming</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">No annual contracts, no data caps & no price increase at 12 months</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">20X faster upload speeds than cable</span>
            </div>
          </div>
          <div className="offer-footer">
            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="standard-call-button">{phoneNumber}</a>
            <p className="disclaimer">Restrictions apply. Internet req'd. Taxes extra. Pricing subj. to change</p>
          </div>
        </div>
        
        {/* Fiber 1000 Mbps - Most Popular */}
        <div className="offer-card offer-card-premium">
          <div className="standard-offer-header">
          <div className="most-popular-badge">Most Popular</div>
            <h3 className="offer-name">AT&T Fiber Internet 1000 Mbps</h3>
            <p className="standard-offer-price">$80<span>/mo. plus taxes</span></p>
          </div>
          <div className="offer-features">
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">Up to 1 GIG speed</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">Unlimited data</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">Ultra-low lag for pro-level gaming</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">25X faster upload speeds than cable</span>
            </div>
          </div>
          <div className="offer-footer">
            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="call-button">{phoneNumber}</a>
            <p className="disclaimer">Restrictions apply. Internet req'd. Taxes extra. Pricing subj. to change</p>
          </div>
        </div>
      </div>

      <div className="offers-cards">
        {/* Fiber + DIRECTV Bundle */}
        <div className="offer-card offer-card-premium">
          <div className="offer-header">
            <h3 className="offer-name">AT&T Fiber + DIRECTV</h3>  
            <p className="offer-price">$139.99<span>/mo.*</span></p>
          </div>
          <div className="offer-features">
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">300 Mbps equal upload and download speeds</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">200+ channels</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">Regional sports networks included</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">DVR to record your favorite shows</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">Max, Paramount+ with SHOWTIME, STARZ®, MGM+™ & Cinemax® included for 3 months*</span>
            </div>
          </div>
          <div className="offer-footer">
            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="call-button">{phoneNumber}</a>
            <p className="disclaimer">*Restrictions apply. Price after 3-mo premium subscription. Taxes extra.</p>
          </div>
        </div>
        
        {/* Fiber 2 GIG */}
        <div className="offer-card offer-card-premium">
          <div className="offer-header">
            <h3 className="offer-name">AT&T Fiber Internet 2 GIG</h3>
            <p className="offer-price">$145<span>/mo. plus taxes</span></p>
          </div>
          <div className="offer-features">
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">2-Gig equal upload and download speeds†</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">Supports next-gen educational and smart home technologies</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">57X faster upload speeds than cable</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">AT&T ActiveArmor℠ advance internet security included</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">Up to 5 AT&T Smart WiFi Extenders included if needed</span>
            </div>
          </div>
          <div className="offer-footer">
            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="call-button">{phoneNumber}</a>
            <p className="disclaimer">Restrictions apply. Internet req'd. †Speeds may vary. Taxes extra.</p>
          </div>
        </div>
        
        {/* Fiber 5 GIG */}
        <div className="offer-card offer-card-premium">
          <div className="offer-header">
            <h3 className="offer-name">AT&T Fiber Internet 5 GIG</h3>
            <p className="offer-price">$245<span>/mo. plus taxes</span></p>
          </div>
          <div className="offer-features">
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">5-Gig equal upload and download speeds†</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">AT&T's max speed for a truly immersive experience</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">134X faster upload speeds than cable</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">AT&T ActiveArmor℠ advance internet security included</span>
            </div>
            <div className="feature-item">
              <span className="feature-check">✓</span>
              <span className="feature-text">Up to 5 AT&T Smart WiFi Extenders included if needed</span>
            </div>
          </div>
          <div className="offer-footer">
            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className="call-button">{phoneNumber}</a>
            <p className="disclaimer">Restrictions apply. Internet req'd. †Speeds may vary. Taxes extra.</p>
          </div>
        </div>
      </div>
    </div>
        
        {/* Testimonial Section */}
        <section className="attTestimonialSection">
          <h2 className="attSectionHeading">What Our Customers Say</h2>
          <div className="attTestimonialContainer">
            <div className="attTestimonial">
              <div className="attStars">★★★★★</div>
              <p className="attTestimonialText">
                "Since switching to AT&T Fiber, our internet has been lightning fast and totally reliable. The installation was smooth, and the pricing is exactly as advertised - no hidden fees!"
              </p>
              <p className="attTestimonialAuthor">- Michael R., AT&T Fiber Customer</p>
            </div>
            <div className="attTestimonial">
              <div className="attStars">★★★★★</div>
              <p className="attTestimonialText">
                "The unlimited data plan has been a game-changer for our family. We stream, game, and work from home without worrying about data caps or slowdowns."
              </p>
              <p className="attTestimonialAuthor">- Sarah L., AT&T Fiber Customer</p>
            </div>
          </div>
        </section>

        {/* FAQ Section - Added for completeness */}
        <section className="attFaqSection">
          <h2 className="attSectionHeading">Frequently Asked Questions</h2>
          <div className="attFaqContainer">
            <div className="attFaqItem">
              <h3 className="attFaqQuestion">What is AT&T Fiber?</h3>
              <p className="attFaqAnswer">
                AT&T Fiber is a high-speed internet service that uses fiber-optic technology to deliver ultra-fast, reliable internet with equal upload and download speeds. It's designed for homes with multiple devices and users who need consistent performance for streaming, gaming, and working from home.
              </p>
            </div>
            <div className="attFaqItem">
              <h3 className="attFaqQuestion">Is AT&T Fiber available in my area?</h3>
              <p className="attFaqAnswer">
                AT&T Fiber is available in select areas across the United States. To check availability in your area, call us at {phoneNumber} and our representatives will be happy to assist you.
              </p>
            </div>
            <div className="attFaqItem">
              <h3 className="attFaqQuestion">Are there any data caps with AT&T Fiber?</h3>
              <p className="attFaqAnswer">
                No, AT&T Fiber plans come with unlimited data. You can stream, download, and game as much as you want without worrying about overage charges or throttling.
              </p>
            </div>
          </div>
        </section>
        
        {/* CTA Section - Added for completeness */}
        <section className="attCtaSection">
          <div className="attCtaContent">
            <h2 className="attCtaHeading">Ready for a Better Connection?</h2>
            <p className="attCtaText">
              Get started with AT&T's reliable services today. Our team is ready to help you find the perfect plan for your needs.
            </p>
            <a href={`tel:${phoneNumber}`} className="attCtaButton">
              <span className="attPhoneIcon">📞</span> Call {phoneNumber}
            </a>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default AttProvider;